export default "__VITE_ASSET__3533a564__"